/* KS Schnellkauf + 3-FÜR-2-Leiste (KING SHAKER-Seite; ss-featured-collection mit Schalter „ks_schnellkauf“)
   - Das Plus legt die erste Variante per XHR in den Warenkorb. XHR statt fetch, weil der fetch-Hook im
     KS-Warenkorb-Drawer sonst bei jedem Plus den Drawer öffnet. Danach KSCartDrawer.refresh() für den
     Zähler im Header. Produkte mit mehreren Varianten (V1) öffnen stattdessen die Produktseite.
   - Leiste unten dunkel (Entscheidung 01.10.2026, die helle Variante ist raus), Akzente in den Farben des
     Warenkorbs: grüner Fortschritt bis zum Geschenk (3. Shaker), gelber Knopf.
     „aktiv“ nur, wenn Shopify einen „… FÜR …“-Rabatt wirklich anwendet (cart_level_discount_applications) —
     die Deals hängen am Bestellwert, nicht an der Stückzahl.
   - Knopf: vor dem Deal „Warenkorb“ (Umriss). Deal aktiv und knapp unter der Versandschwelle (Lücke bis 8,00,
     also mit einem Zubehörteil zu 7,99 € / 8.00 CHF zu schließen; DE: 3 × 29,90 € = 59,80 € → 0,20 €) → gelb
     „Gratis-Versand holen“ (/cart → Drawer mit Fehlbetrag und Zubehör). Sonst gelb „Zur Kasse“ (/checkout): bei
     erreichtem Gratis-Versand, bei großer Lücke (AT frei ab 99 €, CH ab 119 CHF — der 3er-Deal liegt weit
     darunter, dort kein Zubehör-Hinweis) und bei Ländern ohne Versandzone. Shaker = Titel „KING SHAKER® | …“;
     Zubehör wie „KING SHAKER® - GUMMIBODEN“ zählt nicht mit. Beträge wie im Drawer: „29,90 €“, „27.81 CHF“.
   - Wegklicken (×, Handy und Desktop): bleibt für die Sitzung zu (sessionStorage „ks-leiste-zu“ = Warenkorb-Stand aus
     Shaker-Anzahl und Rabatt) und kommt erst wieder, wenn sich dieser Stand ändert, z. B. nach dem nächsten Plus.
   - Messung (Auswertung an den Bestellungen, nichts Personenbezogenes): unsichtbare Warenkorb-Attribute, das „_“
     blendet sie für Kunden aus, das OS liest Bestell-Attribute nicht. _ks_plus = Anzahl Shaker, die per Plus kamen;
     _ks_leiste = letzter Klick auf den Leisten-Knopf (warenkorb | versand | kasse); _ks_leiste_zu = 1, wenn
     weggeklickt. Per XHR (die fetch-Hooks bleiben ruhig), nacheinander; „Zur Kasse“ wartet höchstens 0,8 s darauf,
     weil die Kasse die Attribute beim Anlegen aus dem Warenkorb übernimmt.
   - Rabattstufen (automatische Rabatte, Stand 30.09.2026): 3 FÜR 2 ab 80,70 € −26,90 €, ab 89,70 € −29,90 €,
     ab 107,70 € −34,90 €; 5 FÜR 3 ab 144,50 € −57,80 €. Versand wie im Drawer (sections/ks-cart-drawer.liquid):
     DE frei ab 60 €, AT ab 99 €, CH ab 119 CHF, gerechnet auf den rabattierten Warenwert. Bei Änderung hier,
     in ss-featured-collection.liquid (3er-Deal-Zeile), in der Deal-Kachel der KING SHAKER-Vorlage und im
     Drawer nachziehen. */
(function () {
  if (window.KSSchnellkauf) return;
  window.KSSchnellkauf = true;
  var STUFEN = [[10770, 3490], [8970, 2990], [8070, 2690]];
  var STUFE5 = 14450;
  var STANDARD = 2990;
  var NAH = 800; // Versandlücke, die ein Zubehörteil schließt
  var VERSAND_FREI = window.KSVersandFrei || { DE: 6000, AT: 9900, CH: 11900 };
  var RUHIG = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var CUR = 'EUR', bar = null, el = {}, busy = {};
  var warAktiv = false, warBetrag = 0, ersterStand = true, sollT1 = '', sollT2 = '', zaehlLauf = 0;
  var ZU = 'ks-leiste-zu', stand = '';
  var plusZahl = 0, offen = null, nachher = [], sendet = false;

  var GESCHENK = '<svg class="ks-ziel__geschenk" viewBox="0 0 24 24" aria-hidden="true"><path d="M20 12v9H4v-9M2 7h20v5H2zM12 21V7m0 0H7.5a2.5 2.5 0 1 1 0-5C11 2 12 7 12 7zm0 0h4.5a2.5 2.5 0 1 0 0-5C13 2 12 7 12 7z" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var HAKEN = '<svg class="ks-ziel__haken" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var KREUZ = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>';
  var PFEIL = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h13M13 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function rabatt(c) { for (var i = 0; i < STUFEN.length; i++) if (c >= STUFEN[i][0]) return STUFEN[i][1]; return 0; }
  function geld(c) { var s = (c / 100).toFixed(2); return CUR === 'EUR' ? s.replace('.', ',') + ' €' : s + ' ' + CUR; }
  function istShaker(t) { return /KING SHAKER\S*\s*\|/i.test(t || ''); }
  function land() { try { return (window.Shopify && window.Shopify.country) || ''; } catch (e) { return ''; } }
  function vibriere(m) { if (RUHIG || !navigator.vibrate) return; try { navigator.vibrate(m); } catch (e) {} }
  function neuStarten(x, k) { x.classList.remove(k); void x.offsetWidth; x.classList.add(k); }
  function merke(k, v) { try { if (v === null) window.sessionStorage.removeItem(k); else window.sessionStorage.setItem(k, v); } catch (e) {} }
  function gemerkt(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }

  // Messung: Warenkorb-Attribute setzen, immer nur eine Anfrage gleichzeitig (spätere Werte werden gesammelt)
  function markiere(werte, danach) {
    offen = offen || {};
    for (var k in werte) offen[k] = werte[k];
    if (danach) nachher.push(danach);
    if (!sendet) sende();
  }
  function sende() {
    var werte = offen, fertig = nachher;
    offen = null; nachher = []; sendet = true;
    var x = new XMLHttpRequest();
    x.open('POST', '/cart/update.js');
    x.setRequestHeader('Content-Type', 'application/json');
    x.setRequestHeader('Accept', 'application/json');
    x.onloadend = function () {
      var c = null;
      try { if (x.status >= 200 && x.status < 300) c = JSON.parse(x.responseText); } catch (e) {}
      sendet = false;
      if (offen) sende();
      fertig.forEach(function (f) { f(c); });
    };
    x.send(JSON.stringify({ attributes: werte }));
  }

  function leiste() {
    if (bar) return bar;
    bar = document.createElement('div');
    bar.id = 'ks-dealbar';
    bar.className = 'ks-dealbar';
    bar.hidden = true;
    bar.innerHTML =
      '<div class="ks-dealbar__text" role="status" aria-live="polite"><b data-ks-t1></b><span data-ks-t2></span></div>' +
      '<div class="ks-dealbar__unten">' +
        '<div class="ks-dealbar__fort" aria-hidden="true"><i><i data-ks-fuell></i></i><span class="ks-ziel" data-ks-ziel>' + GESCHENK + HAKEN + '</span></div>' +
        '<a class="ks-dealbar__knopf" data-ks-knopf href="/cart"><span data-ks-ktext>Warenkorb</span>' + PFEIL + '</a>' +
      '</div>' +
      '<button type="button" class="ks-dealbar__zu" data-ks-zu aria-label="Leiste schließen">' + KREUZ + '</button>';
    document.body.appendChild(bar);
    // Einfahr-Animation nach dem Ende abnehmen, damit sie bei späteren Klassenwechseln nicht neu startet
    bar.addEventListener('animationend', function (e) {
      if (e.target !== bar) return;
      if (e.animationName === 'ks-rein') bar.classList.remove('kommt');
      if (e.animationName === 'ks-raus') { bar.classList.remove('geht'); bar.hidden = true; }
    });
    bar.querySelector('[data-ks-zu]').addEventListener('click', schliessen);
    el.text = bar.querySelector('.ks-dealbar__text');
    el.t1 = bar.querySelector('[data-ks-t1]');
    el.t2 = bar.querySelector('[data-ks-t2]');
    el.fuell = bar.querySelector('[data-ks-fuell]');
    el.ziel = bar.querySelector('[data-ks-ziel]');
    el.knopf = bar.querySelector('[data-ks-knopf]');
    el.ktext = bar.querySelector('[data-ks-ktext]');
    return bar;
  }

  // × : Leiste für diesen Warenkorb-Stand ausblenden (Sitzung)
  function schliessen() {
    merke(ZU, stand);
    markiere({ _ks_leiste_zu: '1' });
    document.documentElement.classList.remove('ks-mit-leiste');
    bar.classList.remove('kommt');
    if (RUHIG) { bar.hidden = true; return; }
    neuStarten(bar, 'geht');
    // falls animationend ausbleibt (Animation nicht geladen o. Ä.)
    setTimeout(function () { if (bar.classList.contains('geht')) { bar.classList.remove('geht'); bar.hidden = true; } }, 400);
  }

  function deal(cart) {
    var best = null;
    (cart.cart_level_discount_applications || []).forEach(function (a) {
      var t = String(a.title || '').replace(/[ㅤﾠ]/g, '').replace(/\s+/g, ' ').trim();
      if (/F(Ü|UE)R/i.test(t) && (!best || a.total_allocated_amount > best.betrag)) best = { titel: t, betrag: a.total_allocated_amount };
    });
    return best;
  }

  function zeige(cart) {
    if (!cart || !cart.items) return;
    CUR = cart.currency || 'EUR';
    var p = parseInt((cart.attributes || {})._ks_plus, 10) || 0;
    plusZahl = cart.item_count ? Math.max(plusZahl, p) : 0;
    var n = 0, summe = 0, drin = {};
    cart.items.forEach(function (it) {
      drin[String(it.variant_id)] = true;
      if (istShaker(it.product_title || it.title)) { n += it.quantity; summe += it.original_line_price; }
    });
    document.querySelectorAll('.ks-add[data-ks-variant]').forEach(function (b) {
      var ja = !!drin[b.getAttribute('data-ks-variant')];
      b.classList.toggle('ist-drin', ja);
      b.setAttribute('aria-pressed', ja ? 'true' : 'false');
    });
    anwenden({ n: n, summe: summe, deal: deal(cart), cart: cart });
  }

  function setzeText(t1, t2) {
    if (t1 === sollT1 && t2 === sollT2) return;
    sollT1 = t1; sollT2 = t2;
    el.t1.innerHTML = t1;
    el.t2.innerHTML = t2;
    if (!ersterStand && !RUHIG) neuStarten(el.text, 'wechsel');
  }

  function anwenden(z) {
    var l = leiste();
    if (!z.n && !z.deal) { l.hidden = true; document.documentElement.classList.remove('ks-mit-leiste'); return; }
    var aktiv = !!z.deal;
    stand = z.n + '|' + (aktiv ? z.deal.betrag : 0);
    var zu = gemerkt(ZU);
    if (zu !== null && zu !== stand) { merke(ZU, null); zu = null; }
    el.fuell.style.width = (aktiv ? 100 : Math.min(z.n, 3) / 3 * 100) + '%';
    el.ziel.classList.toggle('lockt', !aktiv && z.n === 2);
    if (aktiv && !el.ziel.classList.contains('erreicht') && !ersterStand && !RUHIG) neuStarten(el.ziel, 'pop');
    el.ziel.classList.toggle('erreicht', aktiv);

    var t1, t2, ktext = 'Warenkorb', href = '/cart';
    if (aktiv) {
      var name = z.deal.titel.replace(/^SALE\s*/i, '').replace(/\s*SALE$/i, '');
      var frei = VERSAND_FREI[land()];
      if (frei && CUR !== (land() === 'CH' ? 'CHF' : 'EUR')) frei = null;
      var fehlt = frei ? frei - z.cart.total_price : 0;
      t1 = '<mark>' + name + '</mark> aktiv – du sparst <em data-ks-zahl>' + geld(z.deal.betrag) + '</em>';
      if (fehlt > 0 && fehlt <= NAH) {
        t2 = 'Noch <em>' + geld(fehlt) + '</em> bis Gratis-Versand – Zubehör dazu?';
        ktext = 'Gratis-Versand holen';
      } else {
        if (z.n === 4 && /^3 /.test(name) && CUR === 'EUR' && z.summe + STANDARD >= STUFE5) t2 = 'Noch 1 Shaker bis <mark>5 FÜR 3</mark>';
        else if (frei && fehlt <= 0) t2 = '<em>Gratis-Versand</em> inklusive';
        else if (z.cart.item_count === z.n) t2 = z.n + ' Shaker für ' + geld(z.cart.total_price) + ' statt ' + geld(z.cart.original_total_price);
        else t2 = 'Der Rabatt ist schon abgezogen';
        ktext = 'Zur Kasse';
        href = '/checkout';
      }
    } else if (z.n >= 3) {
      t1 = z.n + ' Shaker im Warenkorb';
      t2 = 'Deinen Preis siehst du im Warenkorb';
    } else if (z.n === 2) {
      t1 = 'Nur noch 1 Shaker bis <mark>3 FÜR 2</mark>';
      // Stückpreis nur, wenn die Rabattstufe mit einem Standard-Shaker sicher erreicht wird (EUR-Preise wie in DE/AT)
      var g = z.summe + STANDARD, r = CUR === 'EUR' ? rabatt(g) : 0;
      t2 = 'Dann ist einer <em>gratis</em>' + (r ? ' – nur <em>' + geld(Math.floor((g - r) / 3)) + '</em> pro Shaker' : '');
    } else {
      t1 = 'Noch 2 Shaker bis <mark>3 FÜR 2</mark>';
      t2 = 'Dann ist einer <em>gratis</em>';
    }
    setzeText(t1, t2);
    el.knopf.setAttribute('href', href);
    el.ktext.textContent = ktext;
    l.classList.toggle('ist-aktiv', aktiv);
    if (zu !== null) {
      // weggeklickt und seitdem nichts geändert: zu lassen
      if (!l.classList.contains('geht')) l.hidden = true;
      document.documentElement.classList.remove('ks-mit-leiste');
      warAktiv = aktiv;
      warBetrag = aktiv ? z.deal.betrag : 0;
      ersterStand = false;
      return;
    }
    l.classList.remove('geht');
    if (l.hidden) {
      l.hidden = false;
      document.documentElement.classList.add('ks-mit-leiste');
      if (!RUHIG) neuStarten(l, 'kommt');
    }
    if (aktiv && !ersterStand && (!warAktiv || z.deal.betrag !== warBetrag)) {
      if (!warAktiv) vibriere(15);
      zaehle(warAktiv ? warBetrag : 0, z.deal.betrag);
    }
    warAktiv = aktiv;
    warBetrag = aktiv ? z.deal.betrag : 0;
    ersterStand = false;
  }

  // Ersparnis zählt beim Freischalten kurz hoch
  function zaehle(von, bis) {
    var x = bar.querySelector('[data-ks-zahl]'), lauf = ++zaehlLauf, t0 = performance.now();
    if (!x || RUHIG) return;
    function schritt() {
      if (lauf !== zaehlLauf || !x.isConnected) return;
      var p = Math.min(1, (performance.now() - t0) / 650);
      x.textContent = geld(Math.round(von + (bis - von) * (1 - Math.pow(1 - p, 3))));
      if (p < 1) requestAnimationFrame(schritt);
    }
    x.textContent = geld(von);
    requestAnimationFrame(schritt);
  }

  function laden() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(zeige)
      .catch(function () {});
  }

  function legeRein(b) {
    var url = b.getAttribute('data-ks-url');
    if (b.hasAttribute('data-ks-wahl')) { window.location.href = url; return; }
    var id = b.getAttribute('data-ks-variant');
    if (busy[id]) return;
    busy[id] = true;
    b.classList.add('laedt');
    var x = new XMLHttpRequest();
    x.open('POST', '/cart/add.js');
    x.setRequestHeader('Content-Type', 'application/json');
    x.setRequestHeader('Accept', 'application/json');
    x.onload = function () {
      busy[id] = false;
      b.classList.remove('laedt');
      if (x.status < 200 || x.status >= 300) { window.location.href = url; return; }
      b.classList.add('ist-drin');
      if (!RUHIG) neuStarten(b, 'pop');
      vibriere(10);
      // Plus zählen; die Antwort ist der aktuelle Warenkorb und ersetzt das Nachladen
      plusZahl++;
      markiere({ _ks_plus: String(plusZahl) }, function (c) { if (c && c.items) zeige(c); else laden(); });
      if (window.KSCartDrawer && window.KSCartDrawer.refresh) {
        try { window.KSCartDrawer.refresh().catch(function () {}); } catch (e) {}
      }
    };
    x.onerror = function () { busy[id] = false; b.classList.remove('laedt'); window.location.href = url; };
    x.send(JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }));
  }

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.ks-add') : null;
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    legeRein(b);
  });

  // Klick auf den Leisten-Knopf merken. Capture auf window, weil der Drawer /cart-Links schon auf document abfängt.
  window.addEventListener('click', function (e) {
    var k = bar && e.target && e.target.closest ? e.target.closest('[data-ks-knopf]') : null;
    if (!k || !bar.contains(k)) return;
    var ziel = k.getAttribute('href');
    var wert = ziel === '/checkout' ? 'kasse' : bar.classList.contains('ist-aktiv') ? 'versand' : 'warenkorb';
    if (ziel !== '/checkout' && window.KSCartDrawer) { markiere({ _ks_leiste: wert }); return; } // Drawer öffnet, Seite bleibt
    e.preventDefault();
    var weg = false;
    function geh() { if (!weg) { weg = true; window.location.href = ziel; } }
    markiere({ _ks_leiste: wert }, geh);
    setTimeout(geh, 800);
  }, true);

  // Änderungen aus dem Warenkorb-Drawer (fetch /cart/change … ) → Leiste nachziehen
  var f = window.fetch;
  if (f) {
    window.fetch = function (input) {
      var u = typeof input === 'string' ? input : (input && input.url) || '';
      var p = f.apply(this, arguments);
      if (/\/cart\/(change|update|clear|add)/.test(u)) p.then(function () { setTimeout(laden, 60); }).catch(function () {});
      return p;
    };
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) laden(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', laden); else laden();
})();
